import { r as registerInstance, h } from './index-d4808923.js';
import { g as global$1 } from './index.esm-7182addc.js';

const gravityImageCss = ".figure{display:inline-flex;flex-direction:column;margin:0}.figure__img-container{display:inline-flex}.figure__img-container__img{display:inline-flex}.figure--fit-contain,.figure--fit-cover,.figure--fit-none{height:100%;width:100%}.figure--fit-contain .figure__img-container,.figure--fit-cover .figure__img-container,.figure--fit-none .figure__img-container{flex:0 1 auto;height:100%;position:relative}.figure--fit-contain .figure__img-container__img,.figure--fit-cover .figure__img-container__img,.figure--fit-none .figure__img-container__img{height:100%;position:absolute;width:100%}.figure--fit-contain .figure__img-container__img{object-fit:contain}.figure--fit-cover .figure__img-container__img{object-fit:cover}.figure--fit-none .figure__img-container__img{object-fit:none}.caption{margin-top:4px}.caption--show{display:block}.caption--hide{display:none}";
const GravityImageStyle0 = gravityImageCss;

const GravityImage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.caption = '';
        this.fallbackSrc = '';
        this.fit = false;
        this.showCaption = false;
        this.src = '';
        this.path = '';
    }
    watchHandlerSrc() {
        this.checkImgSrc();
    }
    watchHandlerFallbackSrc(newValue) {
        if (this.path !== this.src) {
            this.path = newValue;
        }
    }
    checkImgSrc() {
        this.path = this.src;
        const img = global$1.document.createElement('img');
        img.src = this.path;
        img.onerror = () => (this.path = this.fallbackSrc);
    }
    componentWillLoad() {
        this.checkImgSrc();
    }
    render() {
        const visible = this.showCaption ? 'caption--show' : 'caption--hide';
        return (h("figure", { key: 'b50fe81f773096eb1564aac5477291c9204cc738', class: `
          figure
          ${this.fit ? 'figure--fit-' + this.fit : ''}
        ` }, h("div", { key: 'fd10c0ed2aafd7ddb38d5894a8a79a3ed8cf4a3f', class: "figure__img-container" }, h("img", { key: '87dcc4ff08358fb68be1d1cc952ca4e1b63e2ddd', class: "figure__img-container__img", src: this.path, alt: this.caption, title: this.caption })), this.caption ? (h("figcaption", { class: 'caption ' + visible }, h("gravity-text", { size: "x-small", weight: "regular", color: "dark-subtle" }, this.caption))) : null));
    }
    static get watchers() { return {
        "src": ["watchHandlerSrc"],
        "fallbackSrc": ["watchHandlerFallbackSrc"]
    }; }
};
GravityImage.style = GravityImageStyle0;

export { GravityImage as gravity_image };

//# sourceMappingURL=gravity-image.entry.js.map